var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "-2 -2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5555_51150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_5555_51150",
    x: -0.111328,
    y: 4.33333,
    width: 17,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.111328,
    y: 4.33333,
    width: 17,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 11.3333V6.46492C0.888672 6.35342 1.00602 6.28089 1.10575 6.33076L6.65814 9.10695C7.50273 9.52924 8.49684 9.52924 9.34142 9.10695L14.8938 6.33076C14.9935 6.28089 15.1109 6.35342 15.1109 6.46492V11.3333C15.1109 12.4379 14.2155 13.3333 13.1109 13.3333H2.88867C1.7841 13.3333 0.888672 12.4379 0.888672 11.3333Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 11.3333V6.46492C0.888672 6.35342 1.00602 6.28089 1.10575 6.33076L6.65814 9.10695C7.50273 9.52924 8.49684 9.52924 9.34142 9.10695L14.8938 6.33076C14.9935 6.28089 15.1109 6.35342 15.1109 6.46492V11.3333C15.1109 12.4379 14.2155 13.3333 13.1109 13.3333H2.88867C1.7841 13.3333 0.888672 12.4379 0.888672 11.3333Z",
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_5555_51150",
    x: -0.111328,
    y: 0.888885,
    width: 17,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.111328,
    y: 0.888885,
    width: 17,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 4.66666V5.24062C0.888672 5.29744 0.920772 5.34938 0.97159 5.37479L6.65814 8.21807C7.50273 8.64036 8.49684 8.64036 9.34142 8.21806L15.028 5.37479C15.0788 5.34938 15.1109 5.29744 15.1109 5.24062V4.66666C15.1109 3.56209 14.2155 2.66666 13.1109 2.66666H2.88867C1.7841 2.66666 0.888672 3.56209 0.888672 4.66666Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 4.66666V5.24062C0.888672 5.29744 0.920772 5.34938 0.97159 5.37479L6.65814 8.21807C7.50273 8.64036 8.49684 8.64036 9.34142 8.21806L15.028 5.37479C15.0788 5.34938 15.1109 5.29744 15.1109 5.24062V4.66666C15.1109 3.56209 14.2155 2.66666 13.1109 2.66666H2.88867C1.7841 2.66666 0.888672 3.56209 0.888672 4.66666Z",
    fill: "#F2994A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5555_51150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcn);
export default __webpack_public_path__ + "static/media/message-icn.0e9e2a92bdf7f381f842bcc0e6fe32df.svg";
export { ForwardRef as ReactComponent };